import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import { convertCompilerOptionsFromJson } from 'typescript';
import 'firebase/storage';
import { ensureReportAuth } from './core/reportAuth'
export default {
  namespaced: true,
  state: {
    data: [],
    loading:true,
  },
  mutations: {
    setData(state: any, value: any) {
        state.data = value
      },
      setLoading(state: any, value: any) {
        state.loading = value
      },

  },
  actions: {
    async getMessages({ commit, state }, val) {
        commit('setLoading',true)
        ensureReportAuth().then(async (res) => {
        // firebase.auth().onAuthStateChanged(async function(user) {
       
              console.log("User is signed in.")
              
              // console.log('val',val)
              var docRef = firebase.firestore().collection("messages").doc(val);
              docRef.get().then(async(doc) => {
                  if (doc.exists) {
                     // console.log("Document data:", doc.data());
                      const data=doc.data()
                     
                      if(data){
                 
                          const emailKey = data.user.replace(/\./g, '||')
                          const user=(await firebase.database().ref(`/users/${emailKey}`).once('value')).val()
                          const language=user&&user.language?user.language.toLowerCase():'en'
                          const company=(await firebase.database().ref(`/company/${user.company}`).once('value')).val()
                          data.company_name=company?company.name:''
                          data.date=format(new Date(data.createdate), 'MMM YYYY')
                          data.language=language
                          if(data.suggest && data.suggest.line1_en === 'Needs'){
                              data.image_rating="https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/rating_banner_belowexpectations.png"
                              data.what_makes_rating=language=='en'?`What does ${data.to_name} need to do to meet your expectations?`:`อะไรที่ ${data.to_name} ต้องทำเพื่อให้ ทำได้ตามความคาดหมาย?`
                              data.rating_text=language=='en'?`You received a Needs Improvement Rating`:`You received a Needs Improvement Rating`
      
                            }else if(data.suggest && data.suggest.line1_en === 'Meets'){
      
                              data.image_rating="https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/rating_banner_meetexpectations.png"
                              data.what_makes_rating=language=='en'?`What does ${data.to_name} need to do to exceed your expectations?`:`อะไรที่ ${data.to_name} ต้องทำเพื่อให้ ทำได้เกินความคาดหมาย?`
                              data.rating_text=language=='en'?`You received a Meets Expectations Rating`:'คุณได้รับคะแนน ทำได้ตามความคาดหมาย'
      
      
                            }else if(data.suggest && data.suggest.line1_en === 'Exceeding'){
      
                              data.image_rating="https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/rating_banner_exceedexpectations.png"
                              data.what_makes_rating=language=='en'?`What does ${data.to_name} need to do to be truly outstanding?`:`อะไรที่ ${data.to_name} ต้องทำเพื่อให้ โดดเด่นและน่าจับตามอง?`
                              data.rating_text=language=='en'?`You received a Exceeding Expectations Rating`:`You received a Exceeding Expectations Rating`
      
                              
                            }else {
                              data.image_rating="https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/rating_banner_trulyoutstanding.png"
                              data.what_makes_rating=language=='en'?`What makes ${data.to_name} truly outstanding?`:`อะไรที่ทำให้ ${data.to_name} โดดเด่นและน่าจับตามอง`
                              data.rating_text=language=='en'?`You received a Truly Outstanding Rating`:`คุณได้รับคะแนน โดดเด่นและน่าจับตามอง`
                              
                            }
      
      
      
                          const excel=data?data.excels:[]
                           for(const index in excel){
                              const detail=(await firebase.database().ref(`/excels_detail/${excel[index].key}`).once('value')).val()
                              if(detail){
                                //  console.log(detail)
                                  for(const i in detail){
                                      const filterData=_.find(excel[index].selected,(o:any)=>detail[i].text_en==o.text_en)
                                      detail[i].key=i
                                      if(filterData){
                                          detail[i].status_selected='true'
                                          detail[i].image_selected='https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/check_box_blue_16dp.png'
                                          detail[i].classCss='background-of-check-list blue'
                                      }else{
                                          detail[i].status_selected='false'
                                          detail[i].image_selected='https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/check_box_outline_blank_black_16dp.png'
                                          detail[i].classCss='background-of-check-list'
                                      }
                                  }
                                      data.excels[index].progress=`https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/progress_blue_${excel[index].selected.length}.png` 
                                      data.excels[index].choice=detail
                              }else{
                                  data.excels[index].progress=`https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/progress_blue_${excel[index].selected.length}.png` 
                                  data.excels[index].choice=[]
                              }
                              
                          }
                          if(data.improves){
                           
                            for(const index in data.improves){
                 
                                const detail=(await firebase.database().ref(`/excels_detail/${data.improves[index].key}`).once('value')).val()
                                if(detail){
                                  
                                for(const i in detail){
                                    const filterData=_.find(data.improves[index].selected,(o:any)=>detail[i].text_en==o.text_en)
                                    detail[i].key=i
                                    if(filterData){
                                        detail[i].status_selected='true'
                                        detail[i].image_selected='https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/check_box_orange_16dp.png'
                                        detail[i].classCss='background-of-check-list orange'
                                    }else{
                                        detail[i].status_selected='false'
                                        detail[i].image_selected='https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/check_box_outline_blank_black_16dp.png'
                                        detail[i].classCss='background-of-check-list'
                                    }
                                }
                                
                                
                                data.improves[index].progress=`https://connected-pub.s3.ap-southeast-1.amazonaws.com/happily/peerfeedback/progress_orange_${data.improves[index].selected.length}.png` 
                                data.improves[index].choice=detail
        
                                }
                                
                            }
                              commit('setData', data)
                              commit('setLoading',false)
                                // console.log("data",data)
                          }
                         
                      }
                      
                  } else {
                      // doc.data() will be undefined in this case
                      console.log("No such document!");
                  }
              }).catch((error) => {
                  console.log("Error getting document:", error);
              });
          
      });




      
    }

  },
  getters: {
    data: ({ data }) => {
        return data
      },
      loading: ({ loading }) => {
        return loading
      },
  }
}